exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remote-follow{max-width:220px}.remote-follow .remote-button{width:100%;min-height:28px}", ""]);

// exports
